import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid/Grid";
import uniqueId from "lodash/fp/uniqueId";
import Typography from "@material-ui/core/Typography/Typography";
import OrdersIcon from "../../components/icons/OrdersIcon";
import Link from "@material-ui/core/Link/Link";
import { Link as RouterLink } from "react-router-dom";
import { useStyles } from "src/pages/Warehouses/components/styles";
import { TFunction } from "i18next";
import format from "date-fns/format";
import StatusColor from "src/components/StatusColors";
import { ServiceOrder } from "src/types";
import DeliveryAddressTooltip from "../../components/DeliveryAddressTooltip/";
import ProgressTooltip from "../../components/ProgressTooltip/";
import ServiceStatusesTooltip from "../../components/ServiceStatusesTooltip/";
import Hint from "src/components/Hint";
import WarningIcon from "../../components/icons/WarningIcon";

export interface FieldListType {
  label: string;
  value: any;
}

const ShowWarningIconForStatuses = ["INCOMPLETE"];

const dataList = (t: TFunction, elem: ServiceOrder): FieldListType[] => [
  {
    label: t("labels.table_fields.name"),
    value: elem.name,
  },
  {
    label: t("labels.table_fields.warehouse"),
    value: elem?.warehouse?.displayText,
  },
  {
    label: t("labels.table_fields.seller"),
    value: elem?.seller?.displayText,
  },
  {
    label: t("labels.table_fields.qty"),
    value: elem.childServicesCount,
  },
  {
    label: t("labels.table_fields.created_date"),
    value: !!elem.createdDate ? format(new Date(elem.createdDate), "dd.MM.yyyy") : "",
  },
];
const RelatedOrdersFieldsList: FC<{ data: ServiceOrder }> = ({ data }) => {
  const classes = useStyles();
  const { t } = useTranslation(`common`);
  return (
    <Grid container direction="row" alignItems="center">
      <Grid item xs={4} container alignItems="center" justify="flex-start">
        <OrdersIcon />
        <Link
          className={classes.link}
          component={RouterLink}
          to={`/serviceOrders/details/${data.id}/summary`}
        >
          {data.name}
        </Link>
      </Grid>
      {dataList(t, data).map((ent: FieldListType) => (
        <Grid item xs key={uniqueId("sellers")}>
          <Typography variant="caption">{ent.label}</Typography>
          <Typography variant="body2">{ent.value}</Typography>
        </Grid>
      ))}
      <Grid item xs key={uniqueId("sellers")} container alignContent={"flex-end"}>
        <div>
          <Typography variant="caption">{t("labels.table_fields.status")}</Typography>
          <Typography variant="body2">
            <StatusColor color={data.statusMatchingName} />
          </Typography>
        </div>
      </Grid>
      <Grid item className={classes.dynamicWarningMessage}>
        {ShowWarningIconForStatuses.includes(data.statusMatchingName.toUpperCase()) && (
          <Hint placement="bottom" title={<Typography> {t("labels.row.indicator")}</Typography>}>
            <span>
              <WarningIcon />
            </span>
          </Hint>
        )}
      </Grid>
      <Grid item>
        <DeliveryAddressTooltip title={data.deliveryAddress!} />
      </Grid>
      <Grid item>
        <ProgressTooltip
          completedChildCount={data.completedChildCount!}
          childServicesCount={data.childServicesCount!}
        />
      </Grid>
      <Grid item className={classes.dynamicIcon}>
        {data.childServicesCount! > 0 && <ServiceStatusesTooltip serviceOrderKey={data.id!} />}
      </Grid>
    </Grid>
  );
};

export default RelatedOrdersFieldsList;
